<template>
  <div class="hot-articles">
    <div class="hot-articles-title">热门文章</div>
    <div class="hot-articles-content">
    <div 
      class="hot-articles-item" 
      v-for="(item, index) in hotPostList" 
      :key="'hotpostlist' + index"
      @click = "goPage(item._id, item.category2)"
    >
      <div :style="color(index)">0{{index + 1}}</div><div>{{item.title}}</div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'hot-articles',
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters('post', ['hotPostList']),
  },
  methods: {
    ...mapActions('post', ['getHotPostList']),
    color (index) {
      return {
        color: index === 0 ? '#FFD146' : index === 1 ? '#CBD8E0' : index === 2 ? '#D68A58' : '#EAEAEA'
      }
    },
    goPage (id, category2) {
      window.open('/p/' + id + '?articleType=' + category2[0]._id)
    },
  },
  components: {

  },
  created () {
    this.getHotPostList()
  }
}
</script>

<style lang="scss" scoped>
.hot-articles {
  width: 232px;
  .hot-articles-title {
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    height: 60px;
    line-height: 60px;
    border-bottom :1px solid rgba(234,234,234,1);
  }
  .hot-articles-content {
    text-align: left;
    .hot-articles-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 60px;
      &:hover {
        cursor: pointer
      }
      >:first-child {
        font-size: 30px;
        line-height: 34px;
        color: #EAEAEA;
      }
      >:nth-child(2) {
        margin-left: 16px;
        line-height: 20px;
      }
    }
  }
}
</style>
